// Chart colours shared by the ERP dashboard widgets. Values match the CRM
// dashboard palette (pages/CrmDashboard/crmDashboardUtils.js) so both
// dashboards read as one product.
export const SERIES = {
  blue: "#2a78d6",
  orange: "#eb6834",
  aqua: "#1baf7a",
  yellow: "#eda100",
  magenta: "#e87ba4",
  green: "#008300",
  violet: "#4a3aa7",
  red: "#e34948",
};

export const CATEGORICAL = Object.values(SERIES);

export const INK = {
  primary: "#1f2d3d",
  secondary: "#52514e",
  muted: "#898781",
  grid: "#e1e0d9",
  axis: "#c3c2b7",
};

export const axisTick = { fill: INK.muted, fontSize: 11 };

// KPI tile shades, lightest to deepest blue. `dark` tiles carry white text;
// every dark step keeps white text above 4.5:1 contrast.
const BLUE_STEPS = [
  { from: "#f5f9ff", to: "#e6f0fd", dark: false },
  { from: "#e6f0fd", to: "#d3e4fb", dark: false },
  { from: "#d3e4fb", to: "#bcd5f7", dark: false },
  { from: "#bcd5f7", to: "#9fc1f1", dark: false },
  { from: "#3676c9", to: "#3473c4", dark: true },
  { from: "#3473c4", to: "#2f6bba", dark: true },
  { from: "#2f6bba", to: "#2b64b0", dark: true },
  { from: "#2b64b0", to: "#265ca5", dark: true },
];

// Tile `index` of `count` in a row: spreads the row evenly across the scale,
// so the first tile is always the lightest and the last the deepest.
export const blueTone = (index, count) => {
  const last = BLUE_STEPS.length - 1;
  const step = count > 1 ? Math.round((index * last) / (count - 1)) : 0;
  return BLUE_STEPS[step];
};

// Inline style + class for a tile with that tone.
export const toneProps = (tone) => ({
  className: tone.dark ? " on-dark" : "",
  style: { "--tile-from": tone.from, "--tile-to": tone.to },
});

// Colours chosen by meaning (Balance Summary rows and bars). Each tile renders a soft
// gradient of its colour with dark text, and a solid icon badge; every value
// keeps white glyphs on the badge above 3:1.
export const TILE = {
  sales: "#2a78d6",       // blue    - revenue in
  profit: "#139a6a",      // emerald - gross profit / won revenue
  netProfit: "#6a4fc9",   // violet
  users: "#c27400",       // amber   - people
  attendance: "#0e9493",  // teal
  onboarding: "#7c4dbd",  // purple
  renewals: "#d97706",    // amber   - due soon
  approvals: "#d6457a",   // rose    - needs action
  leads: "#1a8fcc",       // sky
  pipeline: "#4a5bd4",    // indigo
  overdue: "#d03b3b",     // red     - overdue work
  calm: "#64748b",        // slate   - nothing outstanding
};

// Short axis label: 12.5K, 1.2M
export const shortAmount = (val) => {
  const n = Number(val) || 0;
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n;
};
